<h2>Produtos de Assinatura com Falhas de Integração com o Millennium</h2>
<div>
  <ng-container *ngIf="productIntegrationFailures && cols">
    <app-table
      [elements]="productIntegrationFailures"
      [addButton]="false"
      [cols]="cols"
      emptyMessage="Nenhum produto com falha de integração com o Millennium encontrado."
      [exportExcel]="false"
      [exportPdf]="false"
      [lazy]="false"
      sortField="dateCreated"
      [sortOrder]="1"
      [changeColumns]="true"
      [showTitle]="false"
      modelName="registros"
    ></app-table>
  </ng-container>
</div>
